import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getEveryLineStatus } from 'store/dealManagement/selectors';
import { getIsDirectSalesCampaignSharable } from 'modules/api/directSalesCampaign';
import { cancelFunctions } from 'utils/cancelFunctions';
import usePrevious from 'customHooks/usePrevious';
import isEqual from 'lodash/isEqual';
import { getDealId } from 'store/dealManagement/selectors/getDealId';
import { getMarketId } from 'store/publisher/selectors';

export const useIsCampaignPlanSharable = (): boolean => {
  const marketId = useSelector(getMarketId);
  const campaignId = useSelector(getDealId);
  const linesStates = useSelector(getEveryLineStatus);
  const prevLinesStates = usePrevious(linesStates);

  const [isSharable, setIsSharable] = useState(false);

  useEffect(() => {
    const fetchAndSetIsSharable = async (): Promise<void> => {
      try {
        const { sharable } = await getIsDirectSalesCampaignSharable(campaignId, marketId, cancelFunctions);

        setIsSharable(sharable);
      } catch (err) {
        setIsSharable(true);
      }
    };

    if (!marketId || !campaignId || !linesStates.length || isEqual(linesStates, prevLinesStates)) return;

    fetchAndSetIsSharable();
  }, [linesStates, prevLinesStates]);

  return isSharable;
};
